import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  FaCheckDouble,
  FaHandshake,
  FaChartPie,
  FaUserGraduate,
  FaArrowRight,
} from 'react-icons/fa';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { servicesData } from '../data/servicesData';
import './Services.css';

const ICONS = {
  'check-double': <FaCheckDouble />,
  handshake: <FaHandshake />,
  'chart-pie': <FaChartPie />,
  'user-graduate': <FaUserGraduate />,
};

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Nos Services Immobiliers au Maroc | ATAA REALTY"
        description="Quatre métiers complémentaires : expertise & évaluation immobilière, conseil, études immobilières, formation. ATAA REALTY est aligné aux standards RICS et IVS."
        canonical="https://ataarealty.com/services"
        keywords="services immobiliers Maroc, expertise immobilière, conseil immobilier, études immobilières, formation immobilière, RICS, IVS, ATAA Realty"
      />
      <Navbar />

      {/* HERO */}
      <header className="services-page-header">
        <div className="services-header-overlay"></div>
        <div className="container services-title-box anim-up">
          <span className="services-eyebrow">Notre Savoir-Faire</span>
          <h1>Nos Services</h1>
          <p className="services-tagline">
            Quatre métiers complémentaires pour accompagner les décisions
            patrimoniales, financières, juridiques et institutionnelles.
          </p>
        </div>
      </header>

      {/* INTRO */}
      <section className="services-intro">
        <div className="container">
          <div className="services-intro-grid">
            <div className="services-intro-text">
              <span className="intro-eyebrow">CE QUE ATAA FAIT POUR VOUS</span>
              <h2>
                Une offre intégrée d'expertise, de conseil, d'études et de
                formation
              </h2>
            </div>
            <div className="services-intro-body">
              <p>
                Chez <strong>ATAA REALTY</strong>, nos quatre métiers se
                déploient dans une logique de complémentarité, au service
                d'analyses indépendantes, structurées et méthodologiquement
                fondées. Chaque mission est conduite en alignement avec les
                standards <strong>RICS</strong> et les{' '}
                <strong>International Valuation Standards (IVS)</strong>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICE CARDS */}
      <section className="services-cards-section">
        <div className="container">
          <div className="services-cards-grid">
            {servicesData.map((service, idx) => (
              <Link
                key={service.slug}
                to={`/services/${service.slug}`}
                className="services-card"
              >
                <div className="services-card-num">
                  {String(idx + 1).padStart(2, '0')}
                </div>
                <div className="services-card-icon">
                  {ICONS[service.iconKey]}
                </div>
                <span className="services-card-eyebrow">{service.subtitle}</span>
                <h3>{service.title}</h3>
                <p>{service.excerpt}</p>
                <span className="services-card-cta">
                  Découvrir <FaArrowRight />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* BOTTOM CTA */}
      <section className="services-cta">
        <div className="container">
          <h3>Un projet, une question, une situation à clarifier ?</h3>
          <p>
            Échangeons sur votre besoin. Nos équipes vous orienteront vers le
            périmètre d'intervention le plus adapté.
          </p>
          <Link to="/contact" className="services-cta-btn">
            Formulez votre demande <FaArrowRight />
          </Link>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Services;
